import { useEffect, useState } from 'react';
import queryString from 'query-string';

import Layout from '@/components/Layout/Vanilla';
import HubSpotForm from '@/components/HubSpotForm';
import Heading from '@/components/renderers/Heading';
import Hero from '@/components/Hero';
import MarkdownRenderer from '@/components/MarkdownRenderer';
import Section from '@/components/Section';
import { fetchPage, gql } from '@/lib/graphcms';

export default function WriteForGraphCMS({ page, hubspotForm, preview }) {
  const [params, setParams] = useState();

  useEffect(() => {
    const query = queryString.parse(window.location.search);
    setParams(query || {});
  }, []);

  return (
    <Layout seo={page} preview={preview}>
      <Section size="small">
        <Hero {...page} />
      </Section>
      <Section size="small">
        <div className="md:-mx-6 md:flex">
          <div className="md:w-1/2 md:px-6 lg:w-3/5">
            <MarkdownRenderer {...page} />
          </div>
          <div className="my-12 md:w-1/2 md:px-6 lg:w-2/5">
            <div className="md:sticky md:top-0">
              <div className="mb-4 md:-mt-12">
                <Heading level={4}>Submit your pitch!</Heading>
                <hr className="inline-block h-1 w-24 rounded border-0 bg-cornflower md:w-48" />
              </div>
              <HubSpotForm params={params} form={hubspotForm} />
            </div>
          </div>
        </div>
      </Section>
    </Layout>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { page } =
    (await fetchPage(
      gql`
        query writeForGraphCMSPageQuery {
          page(where: { slug: "write-for-graphcms" }) {
            ...pageData # Fragment is inside the method
          }
        }
      `,
      {
        preview,
      },
    )) || [];

  const response = await fetch(
    `https://api.hubapi.com/forms/v2/forms/9eae2844-dcc5-4908-920d-87f4aeb12af8/?hapikey=${process.env.HUBSPOT_API_KEY}`,
  );

  const hubspotForm = await response.json();

  return {
    props: {
      preview,
      page,
      hubspotForm,
    },
    revalidate: 3600,
  };
};
